import styled from 'styled-components';

import { device } from './HelperStyle';

export const MainContent = styled.main`
  background-color: #222222;
  color: white;
  min-height: calc(100vh - 44px);
  width: 100%;
  overflow-x: hidden !important;
`;

export const SectionHeader = styled.div`
  font-size: 60px;
  text-align: center;
  margin-bottom: 40px;
  /* Not margin (padding instead) due to id navigation. 
    Gives it space between the top of page and the actual header when navigating to div
  */
  padding-top: 40px;

`;

export const SectionSubheader = styled.div`
  font-size: 40px;
  text-align: center;
  margin-bottom: 40px;
  margin-top: 40px;

`;

export const SectionText = styled.div`
  font-size: 30px;
  text-align: justify;
  text-justify: inter-word;
  margin: 0 auto;
  margin-top: 40px;
  margin-bottom: 25px;
  width: 750px;
  line-height: 150%;

  @media ${device.tablet} {
    width: 90%;
    text-align: center;
  }

  a {
    color: white;
    text-decoration: underline;
    text-decoration-color: ${(props) => props.linkTheme};
    display: inline;
    transition: 0.22s all ease-in-out;
  }

  a:hover {
    color: var(--color-accent);
    cursor: pointer;
  }
`;
